module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"loading":"Загрузка...","error":"Ошибка!..."}}')
  delete Component.options._Ctor
}
